import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function deleteCenterTeflCostsInvoice(id: number, teflCostId: number, invoiceId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.centers.deleteCenterTeflCostInvoice.url, { id, teflCostId, invoiceId })
    )
    .delete()
}
